module.exports = (goal) => {
  if (!goal) return

  try {
    dataLayer.push({ event: 'data_to_gtm', data_event: goal, data_description: '' })
  } catch (e) { }
}
